<template>
  <div class="bonus" v-if="app != null && app.data != null">
    <div class="launcher" id="zoom-content">
      <div @click="app.displaySettings()" id="boule" class="new-boule">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="30"
          viewBox="0 -960 960 960"
          width="30"
          style="fill: rgb(255, 255, 255)"
        >
          <path
            d="M130.001-254.616V-300h699.998v45.384H130.001Zm0-202.692v-45.384h699.998v45.384H130.001Zm0-202.692v-45.384h699.998V-660H130.001Z"
          />
        </svg>
      </div>
      <div
        v-for="zoom in app.data[app.currentMusee].bonus.filter(
          (x) => x.id == app.currentQuizz
        )"
        :key="zoom"
        id="zoom-selector"
      >
        <div @click="app.backToBonus()" id="zoom">
          <img id="eye" src="eye.png" />
        </div>
        <img :src="zoom.img" />
        <!-- <button @click="app.refreshPage()">Rejouer</button> -->
        <button @click="app.displayAbout(true)">Rejouer</button>
      </div>
    </div>

    <settings v-bind:app="app"></settings>
  </div>
</template>

<script>
import settings from "./settings.vue";

export default {
  name: "BonusVue",
  props: {
    app: Object,
  },
  components: {
    settings,
  },
};
</script>
